import Dashboard from 'views/dashboard';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: '/',
    component: Dashboard,
    documentTitle: 'Dashboard'
  }
];

export default routes;
